import React from 'react';
import { ActivityPost } from '@components/feed/Feed/components/ActivityPost';
import { ICompetitionResumedActivity } from './interfaces';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { CompetitionActivityBody } from '../components/CompetitionActivityBody';
import { getPortalCompetitionDetailsRoute } from '../helpers';

export const CompetitionResumedActivity: React.FC<
  ICompetitionResumedActivity
> = (props): JSX.Element => {
  const navigate = useNavigate();
  const detailsRoute = getPortalCompetitionDetailsRoute(props.slug, props.status);

  const activityTitle = (
    <Trans
      i18nKey={'activities:competitionResumed.title'}
      values={{
        title: props.title,
      }}
      components={{
        bold: <strong />,
      }}
    />
  );

  return (
    <ActivityPost
      title={activityTitle}
      date={props.date}
      icon={PlayArrowIcon}
      onClick={() => navigate(detailsRoute)}
    >
      <CompetitionActivityBody {...props} variant="resumed" />
    </ActivityPost>
  );
};
